const _excluded = ["size"];
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
import React from "react";
var CardUnknown32 = function CardUnknown32(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M0 4a4 4 0 0 1 4-4h21a4 4 0 0 1 4 4v1H0V4z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21 14v6H4a4 4 0 0 1-4-4V9h23.101A6.979 6.979 0 0 0 21 14zM5 14a1 1 0 0 1 1-1h6a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z",
      fill: "currentColor",
    }),
    /*#__PURE__*/ React.createElement("path", {
      d: "M27.693 20.08c.148.068.308.104.47.104a1.13 1.13 0 0 0 .76-.304 1.18 1.18 0 0 0 .369-.746 3.04 3.04 0 0 1 1.036-1.7 5.496 5.496 0 0 0 1.461-2.29 4.006 4.006 0 0 0 .126-2.103 3.952 3.952 0 0 0-.956-1.866 4.127 4.127 0 0 0-1.902-1.058 4.065 4.065 0 0 0-2.164.063 4.01 4.01 0 0 0-1.852 1.138 4.14 4.14 0 0 0-1.009 1.955c-.071.303-.023.622.135.888.157.267.412.459.707.534a1.111 1.111 0 0 0 .866-.142 1.174 1.174 0 0 0 .509-.73c.064-.326.216-.628.44-.87.223-.243.508-.417.823-.502a1.892 1.892 0 0 1 1.835.392 1.65 1.65 0 0 1 .249 1.66 3.52 3.52 0 0 1-.916 1.304 5.222 5.222 0 0 0-1.65 3.064 1.193 1.193 0 0 0 .277.918c.107.124.239.223.386.291zm-.346 1.59c.205-.14.445-.214.691-.214h.004c.33 0 .645.135.877.374a1.293 1.293 0 0 1 .153 1.605 1.24 1.24 0 0 1-.558.468 1.22 1.22 0 0 1-1.355-.276 1.299 1.299 0 0 1-.27-1.386c.095-.232.254-.431.458-.57z",
      fill: "currentColor",
    })
  );
};
CardUnknown32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
var CardUnknown24 = function CardUnknown24(props) {
  return /*#__PURE__*/ React.createElement(
    "svg",
    props,
    /*#__PURE__*/ React.createElement("path", {
      d: "M23 4v1H1V4a3 3 0 0 1 3-3h16a3 3 0 0 1 3 3zM1 7v7a3 3 0 0 0 3 3h8v-.5a6.513 6.513 0 0 1 6.5-6.5 6.392 6.392 0 0 1 4.5 1.83V7H1zm9 6H6a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zm8.347 7a.918.918 0 0 1-.911-1.032c.15-.932.62-1.784 1.327-2.409a2.76 2.76 0 0 0 .736-1.025 1.27 1.27 0 0 0-.2-1.305 1.556 1.556 0 0 0-1.475-.308A1.4 1.4 0 0 0 16.808 15a.912.912 0 0 1-1.674.266.927.927 0 0 1-.108-.699 3.232 3.232 0 0 1 2.3-2.431 3.34 3.34 0 0 1 3.269.782 3.083 3.083 0 0 1 .668 3.12 4.31 4.31 0 0 1-1.175 1.8c-.42.339-.715.81-.833 1.337a.92.92 0 0 1-.908.825zm-.1 1a1 1 0 1 0 .003 0h-.003z",
      fill: "currentColor",
    })
  );
};
CardUnknown24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
};
const sizeMap = {
  32: CardUnknown32,
  24: CardUnknown24,
};
export function CardUnknown(_ref) {
  let { size = "24" } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const Icon = sizeMap[size] || sizeMap["24"];
  if (
    process.env.NODE_ENV !== "production" &&
    process.env.NODE_ENV !== "test" &&
    !sizeMap[size]
  ) {
    throw new Error(
      "The '".concat(
        size,
        "' size is not supported by the 'CardUnknown' icon. Please use one of the available sizes: '24', '32'."
      )
    );
  }
  return /*#__PURE__*/ React.createElement(Icon, props);
}
